jQuery(document).ready(function ($) {
  // Simple accordion functionality
  $('.accordion__group button').on('click', function (e) {
    e.preventDefault();

    // If item clicked on is open, close it
    if ($(this).closest('.accordion__group').hasClass('active')) {
      $(this).closest('.accordion__group').removeClass('active');
      $(this).closest('.accordion__group').find('.accordion__copy').slideUp();
    } else {
      // Otherwise, close all others and open the one clicked on
      $('.accordion__group').removeClass('active');
      $('.accordion__copy').slideUp();
      $(this).closest('.accordion__group').addClass('active');
      $(this).closest('.accordion__group').find('.accordion__copy').slideToggle();
    }
  });
});
jQuery(document).ready(function ($) {
  $('.customer--addresses .add-address').on('click', function (e) {
    $('#address-add').toggle();
    $('#address-list').toggle();
  });
  $('.customer--addresses .add-address-cancel').on('click', function (e) {
    $('#address-add').toggle();
    $('#address-list').toggle();
  });
});
jQuery(document).ready(function ($) {
  // ATC Generic Triggers
  genericATC('.atc--cross');

  // Product ( not cart ) qty update
  $('.js-qty:not(.js-qty--cart)').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;
    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
    }
    qtyInput.val(qtyInputVal);
  });

  // PDP ATC
  $('.pdp__info .btn--atc-pdp').on('click', function (e) {
    e.preventDefault();

    // Get all the vars/qtys
    var varId = $(this).attr('data-var');
    var currentQty = $('input.qty-val').val();
    var addOnIds = $(this).attr('data-addon').split(',');

    // Set up the object array with pdp var/qty
    var prodObject = [{
      id: varId,
      quantity: currentQty
    }];

    // If they exist, add the addon vars/qty to object array
    if (addOnIds != '') {
      $.each(addOnIds, function (index, value) {
        prodObject.push({
          id: value,
          quantity: '1'
        });
      });
    }

    // Finally, add it to the cart
    CartJS.addItems(prodObject, {
      "success": function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      "error": function error(jqXHR, textStatus, errorThrown) {
        alert('Error: ' + errorThrown + '!');
      }
    });
  });

  // Mini Cart Remove Product
  $('.mini-cart').on('click', '.remove-product', function () {
    var lineNum = $(this).closest('.product').data('lineid');
    CartJS.removeItem(lineNum, {
      "success": function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      "error": function error(jqXHR, textStatus, errorThrown) {
        alert('Error: ' + errorThrown + '!');
      }
    });
  });

  // MAIN CART

  // Qty
  $('.quantity-column').on('click', '.js-qty--cart', function (e) {
    e.preventDefault();
    console.log('hti qty');
    var $this = $(this);
    var qtyInput = $this.closest('.product__qty').find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;
    var itemID = $this.closest('.cart-row').data('lineid');
    var lineNum = $this.closest('.cart-row').data('linenum');
    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
    }
    if (qtyInputVal >= 1) {
      CartJS.updateItem(lineNum, qtyInputVal, {}, {
        success: function success(data, textStatus, jqXHR) {
          jQuery.getJSON('/cart.js', function (cart) {
            console.log('hit success HERE');
            $.each(cart.items, function (index, item) {
              if (item.id === itemID) {
                $('[data-lineid="' + itemID + '"] .total-column .body').text(formatter.format(item.final_line_price / 100));
                $('[data-lineid="' + itemID + '"] .quantity-column input').val(item.quantity);
              }
            });
            $('.subtotal-row .cart-subtotal').text(formatter.format(cart.items_subtotal_price / 100));
            var totalShip = parseInt($('.cart').data('freeship'));
            var newCartTotal = cart.items_subtotal_price;
            var awayShip = totalShip - newCartTotal;
            var shipPercent = newCartTotal / totalShip * 100;
            console.log('totalShip: ' + totalShip);
            console.log('newCartTotal: ' + newCartTotal);
            console.log('awayShip: ' + awayShip);
            console.log('shipPercent: ' + shipPercent);
            if (shipPercent >= 100) {
              $('.cart__shipping .shipping-bar--progress').css('width', '100%');
              $('.cart__shipping').addClass('is-free');
            } else {
              if ($('.cart__shipping').hasClass('is-free')) {
                $('.cart__shipping').removeClass('is-free');
              }
              $('.free-count').text(formatter.format(awayShip / 100));
              $('.shipping-bar--progress').css('width', shipPercent + '%');
            }
          });
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log("Error: " + errorThrown + "!");
          console.log(textStatus);
          console.log(jqXHR);
        }
      });
    } else {
      CartJS.removeItem(lineNum, {
        success: function success(data, textStatus, jqXHR) {
          location.reload();
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log("Error: " + errorThrown + "!");
          console.log(textStatus);
          console.log(jqXHR);
        }
      });
    }
  });

  // Cart Remove
  $('.cart-remove').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var itemID = $this.closest('.cart-row').data('lineid');
    var lineNum = $this.closest('.cart-row').data('linenum');
    $('.cart-row').each(function (index, value) {
      $dataLine = $(this).data('linenum');
      console.log($dataLine);
    });
    CartJS.removeItemById(itemID, {
      success: function success(data, textStatus, jqXHR) {
        location.reload();
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log("Error: " + errorThrown + "!");
        console.log(textStatus);
        console.log(jqXHR);
      }
    });
  });

  // SELECT TERMS
  $('.btn--checkout').on('click', function (e) {
    if (!$('.terms__checkbox input').is(':checked')) {
      e.preventDefault();
      alert('You must agree to the terms and conditions before continuing.');
    }
  });
});
function genericATC(selector) {
  $(selector).on('click', function (e) {
    e.preventDefault();
    var varId = $(this).closest('.product').data('varid');
    console.log(varId);
    CartJS.addItem(varId, 1, {}, {
      "success": function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      "error": function error(jqXHR, textStatus, errorThrown) {
        alert('Error: ' + errorThrown + '!');
      }
    });
  });
}
function refreshMiniCart(cartData) {
  var cartItems = cartData.items;
  var newCartHtml = '';

  // Free shipping updater
  var totalShip = parseInt($('.mini-cart').data('freeship'));
  var newCartTotal = cartData.items_subtotal_price;
  var awayShip = totalShip - newCartTotal;
  var shipPercent = newCartTotal / totalShip * 100;
  if (shipPercent >= 100) {
    $('.shipping-bar--progress').css('width', '100%');
    $('.mini-cart__free').addClass('is-free');
  } else {
    if ($('.mini-cart__free').hasClass('is-free')) {
      $('.mini-cart__free').removeClass('is-free');
    }
    $('.free-count').text(formatter.format(awayShip / 100));
    $('.shipping-bar--progress').css('width', shipPercent + '%');
  }

  // Build html of new products in cart
  $.each(cartItems, function (index, item) {
    console.log(item);
    // Opening
    newCartHtml += '<div class="product product--cart d-flex justify-between" data-lineid="' + (index + 1) + '">';
    newCartHtml += ' <div class="product__img">';
    newCartHtml += '<a href="' + item.url + '">';
    newCartHtml += '<img src="' + item.image.replace('.jpg', '_70x.jpg').replace('.png', '_70x.png') + '" srcset="' + item.image.replace('.jpg', '_140x.jpg').replace('.png', '_140x.png') + ' 2x" alt="' + item.image.alt + '">';
    newCartHtml += '</a>';
    newCartHtml += '</div>';
    newCartHtml += '<div class="product__info">';
    newCartHtml += '<h3><a href="' + item.url + '">';
    newCartHtml += item.product_title;
    if (item.variant_options != null) {
      newCartHtml += '<span class="var">';
      $.each(item.variant_options, function (index, value) {
        if (value != 'Default Title') {
          if (index != 0) {
            newCartHtml += ' / ';
          }
          newCartHtml += value;
        }
      });
      newCartHtml += '</span>';
    }
    newCartHtml += '</a></h3>';
    newCartHtml += '<div class="price">' + formatter.format(item.final_line_price / 100) + '</div>';
    newCartHtml += '<div class="bottom d-flex justify-between align-center">';
    newCartHtml += '<div class="qty">Qty: ' + item.quantity + '</div>';
    newCartHtml += '<button class="remove-product">Remove</button>';
    newCartHtml += '</div>';
    newCartHtml += '</div>';

    // Closing
    newCartHtml += '</div>';
  });

  // Clear current products in cart
  $('.mini-cart__items').empty();

  // Set new subtotal
  $('.mini-cart__footer .totals .total').text(formatter.format(cartData.total_price / 100));

  // Set new header icon count
  $('.icon--cart .cart-count span ').text(cartData.item_count);

  // Add updated producst to mini cart
  $('.mini-cart__items').html(newCartHtml);

  // Show mini cart
  $('.mini-cart').fadeIn();
}
jQuery(document).ready(function ($) {
  // Make mobile category selector go to tag page
  $('.blog__tags select').on('change', function () {
    var tagUrl = $(this).val();
    window.location = tagUrl;
  });
});
function calcBeer() {
  /* =====  Variables =====  */
  var barrel_per_year = document.getElementById('barrel_per_year').value;
  var weeks_per_year = document.getElementById('weeks_per_year').value;
  var system_size = document.getElementById('system_size').value;
  var barrel_per_brew = document.getElementById('barrel_per_brew').value;
  var fermenter_size = document.getElementById('fermenter_size').value;

  // var gallon_produced = document.getElementById('gallon_produced').value;
  var gallon_produced = 7875;
  //var waste         = document.getElementById('waste').value;
  var waste = 10;
  var sell_price = document.getElementById('sell_price').value;

  /* =====  Const =====  */
  var avg_fermenter_time = 2.5;

  // Formulas
  var brew_day_per_week = barrel_per_year / system_size / weeks_per_year / barrel_per_brew;
  var cycles_per_year = weeks_per_year / avg_fermenter_time;
  var fermenter_needs = barrel_per_year / cycles_per_year / fermenter_size;
  var beers_on_tap = fermenter_needs;
  var gallon_produced = barrel_per_year * 31;
  var oz_pints = gallon_produced * 128 / 16 * (1 - waste / 100);
  var revenue = oz_pints * sell_price;
  var costs = 100 * barrel_per_year;
  var gross_profit = revenue - costs;
  var gross_profit_m = gross_profit / revenue * 100;
  var brew_system = 16500;
  var fermenters = 2000 * fermenter_needs;
  var chiller = fermenters / 10000 * 2000;
  var total = brew_system + fermenters + chiller;
  // var roi            = gross_profit / total;
  var roi = total / (gross_profit / 12);

  // ===== Output =====
  document.getElementById("days_per_week").innerHTML = Math.round(brew_day_per_week).toLocaleString("en-US");
  document.getElementById("cycles_per_year").innerHTML = cycles_per_year.toLocaleString("en-US");
  document.getElementById("fermenter_needs").innerHTML = Math.ceil(fermenter_needs).toLocaleString("en-US");
  document.getElementById("beers_on_tap").innerHTML = Math.ceil(beers_on_tap).toLocaleString("en-US");
  document.getElementById("gallon_produced").innerHTML = Math.ceil(gallon_produced).toLocaleString("en-US");
  document.getElementById("oz_pints").innerHTML = Math.ceil(oz_pints).toLocaleString("en-US");
  document.getElementById("revenue").innerHTML = Math.ceil(revenue).toLocaleString("en-US");
  document.getElementById("costs").innerHTML = Math.ceil(costs).toLocaleString("en-US");
  document.getElementById("gross_profit").innerHTML = Math.ceil(gross_profit).toLocaleString("en-US");
  document.getElementById("gross_profit_m").innerHTML = Math.ceil(gross_profit_m).toLocaleString("en-US");
  document.getElementById("brew_system_cost").innerHTML = Math.round(brew_system).toLocaleString("en-US");
  document.getElementById("fermenter_cost").innerHTML = Math.round(fermenters).toLocaleString("en-US");
  document.getElementById("chiller_cost").innerHTML = Math.round(chiller).toLocaleString("en-US");
  document.getElementById("total_cost").innerHTML = Math.round(total).toLocaleString("en-US");
  document.getElementById("roi").innerHTML = Math.round(roi).toLocaleString("en-US");
}

//commas to thousands
function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
jQuery(document).ready(function ($) {
  // Home Cat Tabs
  $('.cat-tabs .tabs__list a').on({
    mouseenter: function mouseenter() {
      var dataIndex = $(this).closest('.tab').data('index');
      $('.cat-tabs .tabs__list .tab').removeClass('active');
      $(this).closest('.tab').addClass('active');
      $('.cat-tabs .tabs__images .tab__image').removeClass('active');
      $('.cat-tabs .tabs__images .tab__image[data-index="' + dataIndex + '"]').addClass('active');
    }
  });
  $('.stamped-reviews-badge').unbind('click');
  addEventListenerStamped(document, 'stamped:reviews:loaded', function (e) {
    console.log('event-triggered');
  });
  $('body').on('click', '.pdp .pdp__reviews', function (e) {
    e.stopPropagation();
    e.preventDefault();
    $('html, body').css('scroll-behavior', 'auto');
    console.log('well well well');
    $('.tabs__header button[data-id="reviews"]').click();
    $('html, body').animate({
      scrollTop: $('#more-info').offset().top
    }, 500);
  });

  // $( '.pdp__reviews' ).on( '', function( ) {
  //   console.log( 'clicked' );
  //   $('html, body').animate({
  //     scrollTop: ($('.pdp__tabs').offset().top)
  //   },500);
  // } );

  // Quiz Alert fixed element
  if (getCookie('quizAlert') != 'Hidden') {
    setTimeout(function () {
      $('.quiz-alert').addClass('active');
    }, 3000);
  }
  $('.quiz-alert .alert-close').on('click', function (e) {
    e.preventDefault();
    $('.quiz-alert').removeClass('active');
    setCookie('quizAlert', 'Hidden');
  });
  $('.quiz-alert .btn').on('click', function (e) {
    setCookie('quizAlert', 'Hidden');
  });

  // PPD info tabs

  $('.pdp__tabs .tabs__header button').on('click', function () {
    var dataId = $(this).data('id');
    $('.pdp__tabs .tabs__header button').removeClass('active');
    $('.pdp__tabs .tabs__info .tab').removeClass('active');
    $(this).addClass('active');
    $('.pdp__tabs .tabs__info .tab#' + dataId).addClass('active');
  });
  $('.pdp__tabs .tabs__header button:first-child').click();

  // PPD icon tabs

  $('.pdp__icon-tabs .icon-tabs__header button').on('click', function () {
    var dataId = $(this).data('id');
    $('.pdp__icon-tabs .icon-tabs__header button').removeClass('active');
    $('.pdp__icon-tabs .icon-tabs__content .tab').removeClass('active');
    $(this).addClass('active');
    $('.pdp__icon-tabs .icon-tabs__content .tab#' + dataId).addClass('active');
  });

  // PDP Accordion

  $('.pdp__tabs .acc-head').on('click', function () {
    if ($(this).closest('.tab').hasClass('active')) {
      $(this).closest('.tab').removeClass('active');
      $(this).closest('.tab').find('.inner').slideUp();
    } else {
      $('.pdp__tabs .tab').removeClass('active');
      $('.pdp__tabs .tab .inner').slideUp();
      $(this).closest('.tab').toggleClass('active');
      $(this).closest('.tab').find('.inner').slideToggle();
    }
  });
  $('.pdp__icon-tabs .acc-head').on('click', function () {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).closest('.tab').find('.inner').slideUp();
    } else {
      $('.pdp__icon-tabs .tab .acc-head').removeClass('active');
      $('.pdp__icon-tabs .tab .inner').slideUp();
      $(this).addClass('active');
      $(this).closest('.tab').find('.inner').slideDown();
    }
  });

  // Crew
  $('.crew-more .btn').on('click', function () {
    $('.crew-list--more').slideToggle();
    $('.crew-more .btn').text(function (i, t) {
      return t == 'View Less' ? 'View More' : 'View Less';
    });
  });

  // Process Tooltips
  $('.newbrew-process .actions button').on('click', function () {
    var id = $(this).attr('id');
    $('.newbrew-process .actions button').removeClass('active');
    $(this).addClass('active');
    $('.step-copy div').hide();
    $('.step-copy div[data-id="' + id + '"]').show();
    $('.img-wrap').removeClass('active');
    $('.img-wrap[data-id="' + id + '"]').addClass('active');
  });

  // Blog filter

  $('.filter-wrap button').on('click', function () {
    if ($(this).closest('.filter-wrap').hasClass('active')) {
      $(this).closest('.filter-wrap').removeClass('active');
      $(this).closest('.filter-wrap').find('.filter-opts').slideUp();
    } else {
      $('.filter-wrap').removeClass('active');
      $(this).closest('.filter-wrap').addClass('active');
      $('.filter-wrap .filter-opts').slideUp();
      $(this).closest('.filter-wrap').find('.filter-opts').slideDown();
    }
  });

  // Blog filter mobile

  $('.blog__list .mobile-filter select').on('change', function () {
    var href = $(this).val();
    window.location.href = href;
  });

  // Newbrew steps mobile
  $('.img-wrap .tooltip-wrap .heading').on('click', function () {
    if ($(this).closest('.tooltip').hasClass('active')) {
      $(this).closest('.tooltip').removeClass('active');
      $(this).closest('.tooltip').find('.content').slideUp();
    } else {
      $('.tooltip').removeClass('active');
      $(this).closest('.tooltip').addClass('active');
      $('.tooltip-wrap .content').slideUp();
      $(this).closest('.tooltip').find('.content').slideDown();
    }
  });
});
function setCookie(cookieName, cookieValue) {
  var today = new Date();
  var expire = new Date();
  expire.setTime(today.getTime() + 14515200000);
  document.cookie = cookieName + "=" + encodeURI(cookieValue) + ";expires=" + expire.toGMTString();
}
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
function addEventListenerStamped(el, eventName, handler) {
  if (el.addEventListener) {
    el.addEventListener(eventName, handler);
  } else {
    el.attachEvent('on' + eventName, function () {
      handler.call(el);
    });
  }
}
jQuery(document).ready(function ($) {
  headerOffset();
  var windowWidth = $(window).width();
  if (windowWidth > 768) {
    // Change header to solid bg on hover if not already solid
    $('.header').on({
      mouseenter: function mouseenter() {
        if (!$(this).hasClass('solid') && !$('.fixed-wrap').hasClass('scrolling')) {
          $(this).addClass('solid');
        }
      },
      mouseleave: function mouseleave() {
        if ($(this).hasClass('solid') && !$('.fixed-wrap').hasClass('scrolling')) {
          $(this).removeClass('solid');
        }
      }
    });
  }

  // Trigger mini cart
  $('.icon--cart').on('click', function (e) {
    e.preventDefault();
    $('body').addClass('fixed');
    $('.mini-cart').fadeIn();
  });
  $('.cart--close, .mini-cart__bg').on('click', function () {
    $('.mini-cart').fadeOut();
    $('body').removeClass('fixed');
  });

  // Trigger mobile menu
  $('.header__mobile-trigger button').on('click', function () {
    $('body').toggleClass('mobile-menu-open');
    $(this).toggleClass('menu-active');
    headerOffset();
    $('.mobile-menu').fadeToggle('fast');
    var newsHeight = $('.fixed-wrap .alert-bar').innerHeight();
    if (!$('.fixed-wrap').hasClass('scrolling')) {
      $('.mobile-menu .inner').css('height', 'calc( 100% - ' + (newsHeight + 50) + 'px )');
    } else {
      $('.mobile-menu .inner').css('height', 'calc( 100% - ' + (newsHeight - 20) + 'px )');
    }
  });

  // Mobile Menu open sub menus
  $('.mobile-menu .level-1 a').on('click', function (e) {
    if ($(this).closest('li').hasClass('has-children')) {
      e.preventDefault();
      var dataIndex = $(this).data('index');
      console.log(dataIndex);
      $('.mobile-menu__front').fadeOut('fast', function () {
        $('.mobile-menu__page[data-index="' + dataIndex + '"]').fadeIn('fast');
      });
    }
  });

  // Mobile Menu back to main
  $('.mobile-menu__page a.heading').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.mobile-menu__page').fadeOut('fast', function () {
      $('.mobile-menu__front').fadeIn('fast');
    });
  });

  // Trigger desktop search
  $('.header__icons .icon--search').on('click', function (e) {
    e.preventDefault();
    $('body').toggleClass('search-open');
    $('.desktop-search').fadeToggle('fast');
    $('.desktop-search .boost-pfs-search-box').focus();
  });

  // Update offset on scroll
  $(window).on('scroll resize', function () {
    headerOffset();
  });

  // Update offset on alert bar close
  $('.alert-bar .close--alert').on('click', function () {
    $('.alert-bar').remove();
    var headerHeight = $('.fixed-wrap').innerHeight();
    if (!$('body').hasClass('template__index') && !$('body').hasClass('template__collection') && !$('body').hasClass('template__page--kettles') && !$('body').hasClass('template__page--fermenters') && !$('body').hasClass('template__page--systems') && !$('body').hasClass('template__page--crew') && !$('body').hasClass('template__page--international') && !$('body').hasClass('template__page--warranty') && !$('body').hasClass('template__page--financing') && !$('body').hasClass('template__page--new-brew') && !$('body').hasClass('template__page--home-brew') && !$('body').hasClass('template__page--pro-brew') && !$('body').hasClass('template__blog') && !$('body').hasClass('template__page--jobs') && !$('body').hasClass('template__page--dealer')) {
      $('#main').css('padding-top', headerHeight + 'px');
    } else {
      $('#main').css('padding-top', '0');
    }
  });

  // Offset content from fixed header
  function headerOffset() {
    var headerHeight = $('.fixed-wrap').innerHeight();
    var alertHeight = $('.alert-bar').innerHeight();

    // console.log( headerHeight );

    if (!$('body').hasClass('template__index') && !$('body').hasClass('template__collection') && !$('body').hasClass('template__page--kettles') && !$('body').hasClass('template__page--fermenters') && !$('body').hasClass('template__page--systems') && !$('body').hasClass('template__page--crew') && !$('body').hasClass('template__page--international') && !$('body').hasClass('template__page--warranty') && !$('body').hasClass('template__page--financing') && !$('body').hasClass('template__page--new-brew') && !$('body').hasClass('template__page--home-brew') && !$('body').hasClass('template__page--pro-brew') && !$('body').hasClass('template__blog') && !$('body').hasClass('template__page--jobs') && !$('body').hasClass('template__page--dealer')) {
      $('#main').css('padding-top', headerHeight + 'px');
    } else {
      $('#main').css('padding-top', alertHeight + 'px');
    }
    $('.mobile-menu').css('top', headerHeight + 'px');
    $(window).on('scroll resize', function () {
      var newsHeight = $('.fixed-wrap .alert-bar').innerHeight();
      $('.mobile-menu').css('top', headerHeight + 'px');
      if ($(window).scrollTop() >= 50) {
        $('.fixed-wrap').addClass('scrolling');
        $('.header').addClass('solid');
        if (newsHeight != undefined) {
          $('.fixed-wrap').css('transform', 'translateY(-' + newsHeight + 'px)');
          // $( '.mobile-menu' ).css( 'margin-top',  '-'+newsHeight+'px' );
        }
      } else {
        $('.fixed-wrap').removeClass('scrolling');
        $('.fixed-wrap').css('transform', 'translateY(0)');
        $('.header').removeClass('solid');
        // $( '.mobile-menu' ).css( 'margin-top', '0' );
        // $( '.mini-cart' ).css( 'margin-top', '0' );
      }
    });
  }
  $('.alert-bar__slider').slick({
    infinite: true,
    slideToShow: 1,
    vertical: true,
    autoplay: true,
    dots: false,
    arrows: false,
    autoplaySpeed: 3500
  });
});
jQuery(document).ready(function ($) {
  $('.btn--modal').on('click', function (e) {
    e.preventDefault();
    var modalId = $(this).data('modal');
    if ($(this).hasClass('btn--video')) {
      var videoId = $(this).data('video');
      $('.modal__inner').append('<div class="responsive-wrap"><iframe src="https://player.vimeo.com/video/' + videoId + '" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe></div>');
    }
    if ($(this).hasClass('btn--img')) {
      console.log('hit here!!!!');
      var imgSrc = $(this).attr('href');
      $('.modal__inner').append('<div class="image-wrap"><img src="' + imgSrc + '" /></div>');
    }
    $('.modal#' + modalId).fadeIn('slow');
  });
  $('.modal__bg, .modal__close').on('click', function () {
    $(this).closest('.modal').fadeOut('slow', function () {
      if ($('.modal__inner .responsive-wrap').length !== 0) {
        $('.modal__inner .responsive-wrap').remove();
      }
      if ($('.modal__inner .image-wrap').length !== 0) {
        $('.modal__inner .image-wrap').remove();
      }
    });
  });
});
jQuery(document).ready(function ($) {
  $('.btn--bis').on('click', function (e) {
    e.preventDefault();
    $('.BIS_trigger').click();
  });

  // Get initial option values
  $('#ProductSelect-pdp option').each(function () {
    if ($(this).attr('data-oos') == 'true') {
      // console.log( 'is oos' );
      var oosVal = $(this).attr('data-options');
      // console.log( oosVal );
      // console.log(  $( '.pdp__options select option[data-val="'+oosVal+'"]' ).next( 'option' ).attr( 'data-val' ) )
      // $( '.pdp__options select option[data-val="'+oosVal+'"]' ).removeAttr( 'selected' ).prop(  'disabled', true );
      setTimeout(function () {
        $('.pdp__options select option[data-val="' + oosVal + '"]').append(' - Out of Stock');
      }, 200);
    } else {
      console.log('is not oos');
    }
  });
  $('.pdp__options select').on('change', function () {
    var varName = '';
    $('.pdp__options select').each(function (index) {
      var selectedVar = $.trim($(this).find(':selected').text());
      if (index > 0) {
        varName += ',' + selectedVar;
      } else {
        varName += selectedVar;
      }
    });
    setVariant(varName.replace(' - Out of Stock', '').trim());
  });

  // On option button change
  $('.pdp__options button').on('click', function () {
    console.log('hit button');
    $(this).closest('.option__wrap').find('button').removeClass('active');
    $(this).addClass('active');
    btnOpt = $.trim($(this).data('val'));
    $(this).closest('.option__wrap').find('.hidden-select option[value="' + btnOpt + '"]').prop('selected', true).change();
    var productTitle = $('.pdp__info h1');

    // Hide PortLayout on kettle if TC is selected
    if ($(this).closest('.option__wrap').hasClass('option__wrap--port-type')) {
      if (!$('.pdp__info').hasClass('pdp__info--new-js')) {
        if ($('.option__wrap--port-type button[data-val="Tri-Clamp"]').hasClass('active')) {
          $('#port-layout').hide();
          $('#port-layout select').val('N/A').change();
        } else {
          $('#port-layout').show();
          var firstOpen = $('.option__wrap:eq(2) option:not([disabled]):first').val();
          $('.option__wrap:eq(2) select').val(firstOpen).change();
        }
      }
    }
    if ($.trim(productTitle.text()) == 'Spike Trio System' || $.trim(productTitle.text()) == 'Spike+ Trio System') {
      if ($('button[data-val="TC"]').hasClass('active')) {
        productTitle.text('Spike+ Trio System');
      } else {
        productTitle.text('Spike Trio System');
      }
    }
    if ($.trim(productTitle.text()) == 'Solo System' || $.trim(productTitle.text()) == 'Solo+ System' || $.trim(productTitle.text()) == 'New - Spike+ Solo System' || $.trim(productTitle.text()) == 'New - Spike Solo System') {
      if ($('button[data-val="TC"]').hasClass('active')) {
        productTitle.text('Solo+ System');
      } else {
        productTitle.text('Solo System');
      }
    }
    if ($.trim(productTitle.text()) == 'Kettle' || $.trim(productTitle.text()) == 'Kettle+') {
      if ($('button[data-val="Tri-Clamp"]').hasClass('active')) {
        productTitle.text('Kettle+');
      } else {
        productTitle.text('Kettle');
      }
    }
    if (btnOpt == 'Spike+' && $('#coupler').length > 0) {
      $('#coupler').hide();
      $('#coupler select').find('option[value="N/A"]').prop('selected', true).change();
      return;
    } else {
      $('#coupler select').find('option[value="1 Coupler"]').prop('selected', true).change();
      $('#coupler').show();
      return;
    }
  });

  // Add deep linking to variants
  $('#ProductSelect-pdp').on('change', function () {
    if ('URLSearchParams' in window) {
      var newVar = $(this).find(':selected').val();
      var searchParams = new URLSearchParams(window.location.search);
      searchParams.set("var", newVar);
      var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
      history.replaceState(null, '', newRelativePathQuery);
    }
    var varImg = $('#ProductSelect-pdp').find(':selected').attr('data-var_img');
    console.log(varImg);
    setVarImg(varImg);
  });

  // Change variants on load based on URL param
  var url = new URL(window.location.href);
  if (url.searchParams.get('var')) {
    var varId = url.searchParams.get('var');
    $('#ProductSelect-pdp option[value="' + varId + '"]').prop('selected', true).change();
    var varOpts = $('#ProductSelect-pdp').find(':selected').data('options');
    $.each(varOpts.split(','), function (index, value) {
      $('.option__wrap select option[value="' + value + '"]').prop('selected', true).change();
      $('.option__wrap button[data-val="' + value + '"]').click();
    });
  } else {
    $('.pdp__options select').trigger('change');
    console.log('hit here');
  }

  // Add-on Products
  $('.pdp .pdp__add-ons .form__group--check input').on('change', function () {
    if (this.checked) {
      // Get price, var id, etc
      var addPrice = $(this).closest('.form__group').attr('data-price');
      var currentPrice = $('.pdp__price .price').attr('data-price');
      var newPrice = parseInt(currentPrice) + parseInt(addPrice);
      var varID = $(this).closest('.form__group').attr('data-varid');
      var currentATCVars = $('.btn--atc-pdp').attr('data-addon');
      if (currentATCVars == '') {
        $('.btn--atc-pdp').attr('data-addon', varID);
      } else {
        $('.btn--atc-pdp').attr('data-addon', currentATCVars + ',' + varID);
      }
      $(this).closest('.add-on').addClass('active');
      $('.pdp__price span.price').attr('data-price', parseInt(newPrice));
      $('.pdp__price span.price').text(formatter.format(parseInt(newPrice) / 100));
    } else {
      var addPrice = $(this).closest('.form__group').attr('data-price');
      var currentPrice = $('.pdp__price .price').attr('data-price');
      var newPrice = parseInt(currentPrice) - parseInt(addPrice);
      var varID = $(this).closest('.form__group').attr('data-varid');
      var currentATCVars = $('.btn--atc-pdp').attr('data-addon');
      $('.btn--atc-pdp').attr('data-addon', currentATCVars.replace(',' + varID, '').replace(varID + ',', '').replace(varID, ''));
      $(this).closest('.add-on').removeClass('active');
      $('.pdp__price span.price').attr('data-price', parseInt(newPrice));
      $('.pdp__price span.price').text(formatter.format(parseInt(newPrice) / 100));
    }
  });
});

// Change PDP price based on variant
function updatePrice(price) {
  $('.pdp__price span.price').text(formatter.format(price / 100));
  $('.pdp__price span.price').attr('data-price', price);
}

// Change variants dropdown to reflect current options and update price
function setVariant(opts) {
  // console.log( 'opts: '+ opts );
  // console.log( variantCombos );

  var curSelOpts = opts.split(',');
  var sizeOpt = curSelOpts[0];
  var typOpt = curSelOpts[1];

  // console.log( 'curSelOpts: '+curSelOpts );
  // console.log( 'sizeOpt: '+sizeOpt );
  // console.log( 'typOpt: '+typOpt );

  $('.option__wrap:eq(1) option, .option__wrap:eq(2) option').prop('disabled', true);
  // $( '.option__wrap button' ).hide();

  // console.log( 'variantCombos: '+variantCombos );

  for (var i = 0; i < variantCombos.length; i++) {
    // console.log( 'variantCombos[i].opt_1: '+variantCombos[i].opt_1 );
    // console.log( 'variantCombos[i].opt_2: '+variantCombos[i].opt_2 );
    // console.log( 'variantCombos[i].opt_3: '+variantCombos[i].opt_3 );

    if ($('.pdp__info').hasClass('pdp__info--new-js')) {
      if (typOpt == 'NPT') {
        if ($('.option__wrap:eq(2) option:selected').val() != '2 Coupler NPT') {
          $('.option__wrap:eq(2) [value="2 Coupler NPT"]').prop('disabled', false).prop('selected', true);
          $('.option__wrap:eq(2) select').change();
        }
      }
      if (typOpt == 'Tri-Clamp') {
        $('.option__wrap:eq(2) option:not( [value="2 Coupler NPT"] )').prop('disabled', false);
        if (sizeOpt == '30 Gallon' || sizeOpt == '50 Gallon') {
          // console.log( 'sizeOpt hit' );
          $('.option__wrap:eq(2) [value="Solo Kettle"]').prop('disabled', true);
        }
        if ($('.option__wrap:eq(2) option:selected').val() == '2 Coupler NPT') {
          $('.option__wrap:eq(2) option:not([disabled]):first').prop('selected', true);
          $('.option__wrap:eq(2) select').change();
        }

        // $( '#ProductSelect-pdp [data-options="'+opts+'"]' ).prop('selected', true).change();
      }
    } else {
      for (var i = 0; i < variantCombos.length; i++) {
        if (variantCombos[i].opt_1 == sizeOpt) {
          $('.option__wrap:eq(1) [data-val="' + variantCombos[i].opt_2 + '"]').prop('disabled', false);
          $('.option__wrap:eq(2) [data-val="' + variantCombos[i].opt_3 + '"]').prop('disabled', false);
        }
      }
    }
  }
  $('#ProductSelect-pdp').on('change', function () {
    if ($('#ProductSelect-pdp [data-options="' + opts + '"]').attr('data-oos') == 'true') {
      // $( '.option__wrap select' ).each( function(){
      //  $(this).find( 'option:first' ).prop('selected', true).change();
      // } );

      $('.btn--bis').show();
      $('.product__qty').hide();
      $('.pdp__price ').hide();
      $('.btn--atc-pdp').hide();
      return;
    } else {
      $('.btn--bis').hide();
      $('.product__qty').show();
      $('.pdp__price ').show();
      $('.btn--atc-pdp').show();
    }
  });

  // Deal with sold out variants

  $('#ProductSelect-pdp [data-options="' + opts + '"]').prop('selected', true).change();
  var varId = $('#ProductSelect-pdp').find(':selected').val();
  var varPrice = $('#ProductSelect-pdp').find(':selected').data('price');
  updatePrice(varPrice);
  setTech(varId);
  setAddons(varId);
  $('.btn--atc-pdp').attr('data-var', varId);
  $('.btn--atc-pdp').attr('data-addon', '');
  $('.pdp__add-ons .form__group--check input').prop("checked", false);
}

// Set technical details by var
function setTech(varID) {
  var varId = varID;
  $('.tab-content .tech-var').hide();
  $('.tab-content .tech-var#' + varId).show();
}

// Set addons based on what variant is selected
function setAddons(varId) {
  $('.pdp__add-ons').hide();
  $('.pdp__add-ons[data-addon_id="' + varId + '"]').show();
}

// Go to variant specific image in slider when selected
function setVarImg(imgUrl) {
  if (imgUrl != '' || imgUrl != undefined) {
    $('.pdp__slider--thumb .slick-slide').each(function () {
      var slideSrc = $(this).find('img').attr('src');
      if (slideSrc == imgUrl) {
        $(this).click();
      }
    });
  }
}
jQuery(document).ready(function ($) {
  $('.new-product').each(function () {
    $(this).find('.status-bar .status--active').prevAll().addClass('status--complete');
  });
});
jQuery(document).ready(function ($) {
  // Set quiz to take up entire page
  var headerH = $('.fixed-wrap').innerHeight() + $('.quiz__footer').innerHeight();
  $('.card').css('height', 'calc( 100vh - ' + headerH + 'px )');

  /*** 1A ***/

  // 3a
  var one_a_120_npt_yes = [{
    question: "1",
    answer: "Five 6 packs"
  }, {
    question: "1a",
    answer: "120 V"
  }, {
    question: "2a",
    answer: "NPT"
  }, {
    question: "3a",
    answer: "Yes"
  }];
  var one_a_240_npt_yes = [{
    question: "1",
    answer: "Five 6 packs"
  }, {
    question: "1a",
    answer: "240 V"
  }, {
    question: "2a",
    answer: "NPT"
  }, {
    question: "3a",
    answer: "Yes"
  }];
  var one_a_120_TC_yes = [{
    question: "1",
    answer: "Five 6 packs"
  }, {
    question: "1a",
    answer: "120 V"
  }, {
    question: "2a",
    answer: "TC"
  }, {
    question: "3a",
    answer: "Yes"
  }];
  var one_a_240_TC_yes = [{
    question: "1",
    answer: "Five 6 packs"
  }, {
    question: "1a",
    answer: "240 V"
  }, {
    question: "2a",
    answer: "TC"
  }, {
    question: "3a",
    answer: "Yes"
  }];

  // 4a
  var one_a_120_npt_no_yes = [{
    "question": "1",
    "answer": "Five 6 packs"
  }, {
    "question": "1a",
    "answer": "120 V"
  }, {
    "question": "2a",
    "answer": "NPT"
  }, {
    "question": "3a",
    "answer": "No"
  }, {
    "question": "4a",
    "answer": "Yes"
  }];
  var one_a_240_npt_no_yes = [{
    "question": "1",
    "answer": "Five 6 packs"
  }, {
    "question": "1a",
    "answer": "240 V"
  }, {
    "question": "2a",
    "answer": "NPT"
  }, {
    "question": "3a",
    "answer": "No"
  }, {
    "question": "4a",
    "answer": "Yes"
  }];
  var one_a_120_tc_no_yes = [{
    "question": "1",
    "answer": "Five 6 packs"
  }, {
    "question": "1a",
    "answer": "120 V"
  }, {
    "question": "2a",
    "answer": "TC"
  }, {
    "question": "3a",
    "answer": "No"
  }, {
    "question": "4a",
    "answer": "Yes"
  }];
  var one_a_240_tc_no_yes = [{
    "question": "1",
    "answer": "Five 6 packs"
  }, {
    "question": "1a",
    "answer": "240 V"
  }, {
    "question": "2a",
    "answer": "TC"
  }, {
    "question": "3a",
    "answer": "No"
  }, {
    "question": "4a",
    "answer": "Yes"
  }];

  // 5a
  var one_a_120_npt_no_no_yes = [{
    "question": "1",
    "answer": "Five 6 packs"
  }, {
    "question": "1a",
    "answer": "120 V"
  }, {
    "question": "2a",
    "answer": "NPT"
  }, {
    "question": "3a",
    "answer": "No"
  }, {
    "question": "4a",
    "answer": "No"
  }, {
    "question": "5a",
    "answer": "Yes"
  }];
  var one_a_240_npt_no_no_yes = [{
    "question": "1",
    "answer": "Five 6 packs"
  }, {
    "question": "1a",
    "answer": "240 V"
  }, {
    "question": "2a",
    "answer": "NPT"
  }, {
    "question": "3a",
    "answer": "No"
  }, {
    "question": "4a",
    "answer": "No"
  }, {
    "question": "5a",
    "answer": "Yes"
  }];
  var one_a_120_tc_no_no_yes = [{
    "question": "1",
    "answer": "Five 6 packs"
  }, {
    "question": "1a",
    "answer": "120 V"
  }, {
    "question": "2a",
    "answer": "TC"
  }, {
    "question": "3a",
    "answer": "No"
  }, {
    "question": "4a",
    "answer": "No"
  }, {
    "question": "5a",
    "answer": "Yes"
  }];
  var one_a_240_tc_no_no_yes = [{
    "question": "1",
    "answer": "Five 6 packs"
  }, {
    "question": "1a",
    "answer": "240 V"
  }, {
    "question": "2a",
    "answer": "TC"
  }, {
    "question": "3a",
    "answer": "No"
  }, {
    "question": "4a",
    "answer": "No"
  }, {
    "question": "5a",
    "answer": "Yes"
  }];
  var one_a_120_npt_no_no_no = [{
    "question": "1",
    "answer": "Five 6 packs"
  }, {
    "question": "1a",
    "answer": "120 V"
  }, {
    "question": "2a",
    "answer": "NPT"
  }, {
    "question": "3a",
    "answer": "No"
  }, {
    "question": "4a",
    "answer": "No"
  }, {
    "question": "5a",
    "answer": "No"
  }];
  var one_a_240_npt_no_no_no = [{
    "question": "1",
    "answer": "Five 6 packs"
  }, {
    "question": "1a",
    "answer": "240 V"
  }, {
    "question": "2a",
    "answer": "NPT"
  }, {
    "question": "3a",
    "answer": "No"
  }, {
    "question": "4a",
    "answer": "No"
  }, {
    "question": "5a",
    "answer": "No"
  }];
  var one_a_120_tc_no_no_no = [{
    "question": "1",
    "answer": "Five 6 packs"
  }, {
    "question": "1a",
    "answer": "120 V"
  }, {
    "question": "2a",
    "answer": "TC"
  }, {
    "question": "3a",
    "answer": "No"
  }, {
    "question": "4a",
    "answer": "No"
  }, {
    "question": "5a",
    "answer": "No"
  }];
  var one_a_240_tc_no_no_no = [{
    "question": "1",
    "answer": "Five 6 packs"
  }, {
    "question": "1a",
    "answer": "240 V"
  }, {
    "question": "2a",
    "answer": "TC"
  }, {
    "question": "3a",
    "answer": "No"
  }, {
    "question": "4a",
    "answer": "No"
  }, {
    "question": "5a",
    "answer": "No"
  }];

  /*** 1B ***/

  // 3b
  var one_b_single_npt_yes = [{
    "question": "1",
    "answer": "Two 30 cases"
  }, {
    "question": "1b",
    "answer": "Single Vessel Solo System"
  }, {
    "question": "2b",
    "answer": "NPT"
  }, {
    "question": "3b",
    "answer": "Yes"
  }];
  var one_b_single_tc_yes = [{
    "question": "1",
    "answer": "Two 30 cases"
  }, {
    "question": "1b",
    "answer": "Single Vessel Solo System"
  }, {
    "question": "2b",
    "answer": "TC"
  }, {
    "question": "3b",
    "answer": "Yes"
  }];
  var one_b_trio_npt_yes = [{
    "question": "1",
    "answer": "Two 30 cases"
  }, {
    "question": "1b",
    "answer": "Trio System"
  }, {
    "question": "2b",
    "answer": "NPT"
  }, {
    "question": "3b",
    "answer": "Yes"
  }];
  var one_b_trio_tc_yes = [{
    "question": "1",
    "answer": "Two 30 cases"
  }, {
    "question": "1b",
    "answer": "Trio System"
  }, {
    "question": "2b",
    "answer": "TC"
  }, {
    "question": "3b",
    "answer": "Yes"
  }];

  // 4b
  var one_b_single_npt_no_yes = [{
    "question": "1",
    "answer": "Two 30 cases"
  }, {
    "question": "1b",
    "answer": "Single Vessel Solo System"
  }, {
    "question": "2b",
    "answer": "NPT"
  }, {
    "question": "3b",
    "answer": "No"
  }, {
    "question": "4b",
    "answer": "Yes"
  }];
  var one_b_single_tc_no_yes = [{
    "question": "1",
    "answer": "Two 30 cases"
  }, {
    "question": "1b",
    "answer": "Single Vessel Solo System"
  }, {
    "question": "2b",
    "answer": "TC"
  }, {
    "question": "3b",
    "answer": "No"
  }, {
    "question": "4b",
    "answer": "Yes"
  }];
  var one_b_trio_npt_no_yes = [{
    "question": "1",
    "answer": "Two 30 cases"
  }, {
    "question": "1b",
    "answer": "Trio System"
  }, {
    "question": "2b",
    "answer": "NPT"
  }, {
    "question": "3b",
    "answer": "No"
  }, {
    "question": "4b",
    "answer": "Yes"
  }];
  var one_b_trio_tc_no_yes = [{
    "question": "1",
    "answer": "Two 30 cases"
  }, {
    "question": "1b",
    "answer": "Trio System"
  }, {
    "question": "2b",
    "answer": "TC"
  }, {
    "question": "3b",
    "answer": "No"
  }, {
    "question": "4b",
    "answer": "Yes"
  }];

  // 5b
  var one_b_single_npt_no_no_yes = [{
    "question": "1",
    "answer": "Two 30 cases"
  }, {
    "question": "1b",
    "answer": "Single Vessel Solo System"
  }, {
    "question": "2b",
    "answer": "NPT"
  }, {
    "question": "3b",
    "answer": "No"
  }, {
    "question": "4b",
    "answer": "No"
  }, {
    "question": "5b",
    "answer": "Yes"
  }];
  var one_b_single_tc_no_no_yes = [{
    "question": "1",
    "answer": "Two 30 cases"
  }, {
    "question": "1b",
    "answer": "Single Vessel Solo System"
  }, {
    "question": "2b",
    "answer": "TC"
  }, {
    "question": "3b",
    "answer": "No"
  }, {
    "question": "4b",
    "answer": "No"
  }, {
    "question": "5b",
    "answer": "Yes"
  }];
  var one_b_trio_npt_no_no_yes = [{
    "question": "1",
    "answer": "Two 30 cases"
  }, {
    "question": "1b",
    "answer": "Trio System"
  }, {
    "question": "2b",
    "answer": "NPT"
  }, {
    "question": "3b",
    "answer": "No"
  }, {
    "question": "4b",
    "answer": "No"
  }, {
    "question": "5b",
    "answer": "Yes"
  }];
  var one_b_trio_tc_no_no_yes = [{
    "question": "1",
    "answer": "Two 30 cases"
  }, {
    "question": "1b",
    "answer": "Trio System"
  }, {
    "question": "2b",
    "answer": "TC"
  }, {
    "question": "3b",
    "answer": "No"
  }, {
    "question": "4b",
    "answer": "No"
  }, {
    "question": "5b",
    "answer": "Yes"
  }];
  var one_b_single_npt_no_no_no = [{
    "question": "1",
    "answer": "Two 30 cases"
  }, {
    "question": "1b",
    "answer": "Single Vessel Solo System"
  }, {
    "question": "2b",
    "answer": "NPT"
  }, {
    "question": "3b",
    "answer": "No"
  }, {
    "question": "4b",
    "answer": "No"
  }, {
    "question": "5b",
    "answer": "No"
  }];
  var one_b_single_tc_no_no_no = [{
    "question": "1",
    "answer": "Two 30 cases"
  }, {
    "question": "1b",
    "answer": "Single Vessel Solo System"
  }, {
    "question": "2b",
    "answer": "TC"
  }, {
    "question": "3b",
    "answer": "No"
  }, {
    "question": "4b",
    "answer": "No"
  }, {
    "question": "5b",
    "answer": "No"
  }];
  var one_b_trio_npt_no_no_no = [{
    "question": "1",
    "answer": "Two 30 cases"
  }, {
    "question": "1b",
    "answer": "Trio System"
  }, {
    "question": "2b",
    "answer": "NPT"
  }, {
    "question": "3b",
    "answer": "No"
  }, {
    "question": "4b",
    "answer": "No"
  }, {
    "question": "5b",
    "answer": "No"
  }];
  var one_b_trio_tc_no_no_no = [{
    "question": "1",
    "answer": "Two 30 cases"
  }, {
    "question": "1b",
    "answer": "Trio System"
  }, {
    "question": "2b",
    "answer": "TC"
  }, {
    "question": "3b",
    "answer": "No"
  }, {
    "question": "4b",
    "answer": "No"
  }, {
    "question": "5b",
    "answer": "No"
  }];

  /*** 1C ***/

  // 3c
  var one_c_single_npt_yes = [{
    "question": "1",
    "answer": "Half a keg"
  }, {
    "question": "1c",
    "answer": "Single Vessel Solo System"
  }, {
    "question": "2c",
    "answer": "NPT"
  }, {
    "question": "3c",
    "answer": "Yes"
  }];
  var one_c_single_tc_yes = [{
    "question": "1",
    "answer": "Half a keg"
  }, {
    "question": "1c",
    "answer": "Single Vessel Solo System"
  }, {
    "question": "2c",
    "answer": "TC"
  }, {
    "question": "3c",
    "answer": "Yes"
  }];
  var one_c_trio_npt_yes = [{
    "question": "1",
    "answer": "Half a keg"
  }, {
    "question": "1c",
    "answer": "Trio System"
  }, {
    "question": "2c",
    "answer": "NPT"
  }, {
    "question": "3c",
    "answer": "Yes"
  }];
  var one_c_trio_tc_yes = [{
    "question": "1",
    "answer": "Half a keg"
  }, {
    "question": "1c",
    "answer": "Trio System"
  }, {
    "question": "2c",
    "answer": "TC"
  }, {
    "question": "3c",
    "answer": "Yes"
  }];
  var one_c_single_npt_no = [{
    "question": "1",
    "answer": "Half a keg"
  }, {
    "question": "1c",
    "answer": "Single Vessel Solo System"
  }, {
    "question": "2c",
    "answer": "NPT"
  }, {
    "question": "3c",
    "answer": "No"
  }];
  var one_c_single_tc_no = [{
    "question": "1",
    "answer": "Half a keg"
  }, {
    "question": "1c",
    "answer": "Single Vessel Solo System"
  }, {
    "question": "2c",
    "answer": "TC"
  }, {
    "question": "3c",
    "answer": "No"
  }];
  var one_c_trio_npt_no = [{
    "question": "1",
    "answer": "Half a keg"
  }, {
    "question": "1c",
    "answer": "Trio System"
  }, {
    "question": "2c",
    "answer": "NPT"
  }, {
    "question": "3c",
    "answer": "No"
  }];
  var one_c_trio_tc_no = [{
    "question": "1",
    "answer": "Half a keg"
  }, {
    "question": "1c",
    "answer": "Trio System"
  }, {
    "question": "2c",
    "answer": "TC"
  }, {
    "question": "3c",
    "answer": "No"
  }];

  /*** 1D ***/

  // 3d
  var one_d_npt_yes = [{
    "question": "1",
    "answer": "1 keg"
  }, {
    "question": "1d",
    "answer": "NPT"
  }, {
    "question": "2d",
    "answer": "Yes"
  }];
  var one_d_tc_yes = [{
    "question": "1",
    "answer": "1 keg"
  }, {
    "question": "1d",
    "answer": "TC"
  }, {
    "question": "2d",
    "answer": "Yes"
  }];
  var one_d_npt_no = [{
    "question": "1",
    "answer": "1 keg"
  }, {
    "question": "1d",
    "answer": "NPT"
  }, {
    "question": "2d",
    "answer": "No"
  }];
  var one_d_tc_no = [{
    "question": "1",
    "answer": "1 keg"
  }, {
    "question": "1d",
    "answer": "TC"
  }, {
    "question": "2d",
    "answer": "No"
  }];

  /*** 1E ***/

  // 3e ( Trio )
  var one_e_trio_npt_yes = [{
    "question": "1",
    "answer": "2 kegs"
  }, {
    "question": "1e",
    "answer": "Trio"
  }, {
    "question": "2e-1",
    "answer": "NPT"
  }, {
    "question": "3e",
    "answer": "Yes"
  }];
  var one_e_trio_tc_yes = [{
    "question": "1",
    "answer": "2 kegs"
  }, {
    "question": "1e",
    "answer": "Trio"
  }, {
    "question": "2e-1",
    "answer": "TC"
  }, {
    "question": "3e",
    "answer": "Yes"
  }];
  var one_e_trio_npt_no = [{
    "question": "1",
    "answer": "2 kegs"
  }, {
    "question": "1e",
    "answer": "Trio"
  }, {
    "question": "2e-1",
    "answer": "NPT"
  }, {
    "question": "3e",
    "answer": "No"
  }];
  var one_e_trio_tc_no = [{
    "question": "1",
    "answer": "2 kegs"
  }, {
    "question": "1e",
    "answer": "Trio"
  }, {
    "question": "2e-1",
    "answer": "TC"
  }, {
    "question": "3e",
    "answer": "No"
  }];
  var one_e_nano_single_batch_yes = [{
    "question": "1",
    "answer": "2 kegs"
  }, {
    "question": "1e",
    "answer": "Nano"
  }, {
    "question": "2e-2",
    "answer": "Single Batch"
  }, {
    "question": "3e",
    "answer": "Yes"
  }];
  var one_e_nano_double_batch_yes = [{
    "question": "1",
    "answer": "2 kegs"
  }, {
    "question": "1e",
    "answer": "Nano"
  }, {
    "question": "2e-2",
    "answer": "Double Batch"
  }, {
    "question": "3e",
    "answer": "Yes"
  }];
  var one_e_nano_single_batch_no = [{
    "question": "1",
    "answer": "2 kegs"
  }, {
    "question": "1e",
    "answer": "Nano"
  }, {
    "question": "2e-2",
    "answer": "Single Batch"
  }, {
    "question": "3e",
    "answer": "No"
  }];
  var one_e_nano_double_batch_no = [{
    "question": "1",
    "answer": "2 kegs"
  }, {
    "question": "1e",
    "answer": "Nano"
  }, {
    "question": "2e-2",
    "answer": "Double Batch"
  }, {
    "question": "3e",
    "answer": "No"
  }];

  /*** Answer Combos ***/

  var masterArray = [/*** 1A ***/

  // 3a
  one_a_120_npt_yes, one_a_240_npt_yes, one_a_120_TC_yes, one_a_240_TC_yes,
  // 4a
  one_a_120_npt_no_yes, one_a_240_npt_no_yes, one_a_120_tc_no_yes, one_a_240_tc_no_yes,
  // 5a
  // - yes -
  one_a_120_npt_no_no_yes, one_a_240_npt_no_no_yes, one_a_120_tc_no_no_yes, one_a_240_tc_no_no_yes,
  // - no -
  one_a_120_npt_no_no_no, one_a_240_npt_no_no_no, one_a_120_tc_no_no_no, one_a_240_tc_no_no_no, /*** 1B ***/

  // 3b
  one_b_single_npt_yes, one_b_single_tc_yes, one_b_trio_npt_yes, one_b_trio_tc_yes,
  // 4b
  one_b_single_npt_no_yes, one_b_single_tc_no_yes, one_b_trio_npt_no_yes, one_b_trio_tc_no_yes,
  // 5b
  // - yes -
  one_b_single_npt_no_no_yes, one_b_single_tc_no_no_yes, one_b_trio_npt_no_no_yes, one_b_trio_tc_no_no_yes,
  // - no -
  one_b_single_npt_no_no_no, one_b_single_tc_no_no_no, one_b_trio_npt_no_no_no, one_b_trio_tc_no_no_no, /*** 1C ***/

  // 3c
  // - yes -
  one_c_single_npt_yes, one_c_single_tc_yes, one_c_trio_npt_yes, one_c_trio_tc_yes,
  // - no -
  one_c_single_npt_no, one_c_single_tc_no, one_c_trio_npt_no, one_c_trio_tc_no, /*** 1D ***/

  // 3d
  // - yes -
  one_d_npt_yes, one_d_tc_yes,
  // - no -
  one_d_npt_no, one_d_tc_no, /*** 1E ***/

  // 3e ( Trio )
  // - yes -
  one_e_trio_npt_yes, one_e_trio_tc_yes,
  // - no -
  one_e_trio_npt_no, one_e_trio_tc_no,
  // 3e ( Nano )
  // - yes -
  one_e_nano_single_batch_yes, one_e_nano_double_batch_yes,
  // - no -
  one_e_nano_single_batch_no, one_e_nano_double_batch_no];

  /*** Products for Answer Comboss ***/

  var productArray = [/*** 1A ***/

  // 3a
  '10-gal-solo',
  // one_a_120_npt_yes
  '10-gal-solo',
  // one_a_240_npt_yes
  '10-gal-solo_plus',
  // one_a_120_TC_yes
  '10-gal-solo_plus',
  // one_a_240_TC_yes

  // 4a
  '10-gal-solo:cf5-conical',
  // one_a_120_npt_no_yes
  '10-gal-solo:cf5-conical',
  // one_a_240_npt_no_no_yes
  '10-gal-solo_plus:cf5-conical',
  // one_a_120_tc_no_no_yes
  '10-gal-solo_plus:cf5-conical',
  // one_a_240_tc_no_yes

  // 5a 
  // - yes -
  '10-gal-solo:flex-plus',
  // one_a_120_npt_no_no_yes
  '10-gal-solo:flex-plus',
  // one_a_240_npt_no_no_yes
  '10-gal-solo_plus:flex-plus',
  // one_a_120_tc_no_no_yes
  '10-gal-solo_plus:flex-plus',
  // one_a_240_tc_no_no_yes

  // - no -
  '10-gal-solo:flex',
  // one_a_120_npt_no_no_no
  '10-gal-solo:flex',
  // one_a_240_npt_no_no_no
  '10-gal-solo_plus:flex',
  // one_a_120_tc_no_no_no
  '10-gal-solo_plus:flex',
  // one_a_240_tc_no_no_no

  /*** 1B ***/

  // 3b
  '15-gal-solo',
  // one_b_single_npt_yes
  '15-gal-solo_plus',
  // one_b_single_tc_yes

  '10-gal-trio',
  // one_b_trio_npt_yes
  '10-gal-trio_plus',
  // one_b_trio_tc_yes

  // 4b
  '15-gal-solo:cf5-conical',
  // one_b_single_npt_no_yes
  '15-gal-solo_plus:cf5-conical',
  // one_b_single_tc_no_yes

  '10-gal-trio:cf5-conical',
  // one_b_trio_npt_no_yes
  '10-gal-trio_plus:cf5-conical',
  // one_b_trio_tc_no_yes

  // 5b
  // - yes -
  '15-gal-solo:flex-plus',
  // one_b_single_npt_no_no_yes
  '15-gal-solo_plus:flex-plus',
  // one_b_single_tc_no_no_yes

  '10-gal-trio:flex-plus',
  // one_b_trio_npt_no_no_yes
  '10-gal-trio_plus:flex-plus',
  // one_b_trio_tc_no_no_yes

  // - no -
  '15-gal-solo:flex',
  // one_b_single_npt_no_no_no
  '15-gal-solo_plus:flex',
  // one_b_single_tc_no_no_no

  '10-gal-trio:flex',
  // one_b_trio_npt_no_no_no
  '10-gal-trio_plus:flex',
  // one_b_trio_tc_no_no_no

  /*** 1C ***/

  // 3c
  // - yes -
  '20-gal-solo',
  // one_c_single_npt_yes
  '20-gal-solo_plus',
  // one_c_single_tc_yes

  '15-gal-trio',
  // one_c_trio_npt_yes
  '15-gal-trio_plus',
  // one_c_trio_tc_yes

  // - no -
  '20-gal-solo:cf10-conical',
  // one_c_single_npt_no
  '20-gal-solo_plus:cf10-conical',
  // one_c_single_tc_no

  '15-gal-trio:cf10-conical',
  // one_c_trio_npt_no
  '15-gal-trio_plus:cf10-conical',
  // one_c_trio_tc_no

  /*** 1D ***/

  // 3d
  // - yes -
  '20-gal-trio',
  // one_d_npt_yes
  '20-gal-trio_plus',
  // one_d_tc_yes

  // - no -
  '20-gal-trio:cf15-conical',
  // one_d_npt_no
  '20-gal-trio_plus:cf15-conical',
  // one_d_tc_no

  /*** 1E ***/

  // 3e ( TRIO )
  // - yes -
  '50-gal-trio',
  // one_e_trio_npt_yes
  '50-gal-trio_plus',
  // one_e_trio_npt_yes

  // - no -
  '50-gal-trio:cf30-conical',
  // one_e_trio_npt_no
  '50-gal-trio_plus:cf30-conical',
  // one_e_trio_npt_no

  // 3e ( NANO )
  // - yes -
  'nano-single',
  // one_e_nano_single_batch_yes
  'nano-double',
  // one_e_nano_double_batch_yes

  // - no -
  'nano-single:cf30-conical',
  // one_e_nano_single_batch_noe
  'nano-double:cf30-conical' // one_e_nano_double_batch_no
  ];

  // Setup empty answer object
  var answers = [];

  // Begin Quiz
  $('.card--start .btn').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.card').fadeOut('fast', function () {
      $('.quiz__footer .btn').css('opacity', '1');
      $('.btn--back').css('opacity', '1');
      $('.card--one').fadeIn('fast');
      $('.card--one').addClass('current-card');
    });
  });

  // Choose Choice
  $('.card .choice button').on('click', function () {
    $('.card .choice').removeClass('active');
    $(this).closest('.choice').addClass('active');
    $('.quiz__footer .btn').prop('disabled', false);
  });

  // Go To Next Question
  $('.quiz__footer .btn').on('click', function (e) {
    e.preventDefault();
    var nextQuestion = $('.current-card .choice.active button').val();
    var currentAnswer = $('.current-card .choice.active button .choice__title').text();
    var currentQuestion = $('.current-card').attr('data-card');

    // Push our question and answer to object
    answers.push({
      question: $.trim(currentQuestion),
      answer: $.trim(currentAnswer)
    });

    // If we've hit show then show the product
    if (nextQuestion == 'showResult') {
      matchObjects(answers, masterArray, productArray);
      $('.quiz__footer, .btn--back').hide();
      setPercent('100');
    } else {
      // Otherwise, go to the next card
      $('.current-card').fadeOut('fast', function () {
        $('.card').removeClass('current-card');
        $('.card .choice').removeClass('active');
        $('.card[data-card="' + nextQuestion + '"]').fadeIn().addClass('current-card');
        var currentPercent = $('.current-card').attr('data-percent');
        setPercent(currentPercent);
        $('.quiz__footer .btn').prop('disabled', true);
      });
    }
    console.log(answers);
  });

  // Go back one question
  $('.btn--back').on('click', function (e) {
    e.preventDefault();

    // Get our previous card
    var prevQuestion = $('.current-card').attr('data-prev');

    // Show previous card
    $('.current-card').fadeOut('fast', function () {
      $('.card').removeClass('current-card');
      $('.card .choice').removeClass('active');
      $('.card[data-card="' + prevQuestion + '"]').fadeIn().addClass('current-card');
      var currentPercent = $('.current-card').attr('data-percent');
      setPercent(currentPercent);
      $('.quiz__footer .btn').prop('disabled', true);
    });

    // Remove last answer from anwer array
    answers.splice(-1);
  });

  // Show upgrade modal
  $('.product .btn--upgrade').on('click', function (e) {
    e.preventDefault();
    var upgradeProd = $(this).attr('data-upgrade');
    $('.product[data-prod="' + upgradeProd + '"]').addClass('product--modal');
    $('.fixed-wrap').addClass('showing-modal');
  });

  // Close upgrade modal
  $('.product .btn--close, .product .icon--close').on('click', function (e) {
    e.preventDefault();
    $(this).closest('.product').removeClass('product--modal');
    $('.fixed-wrap').removeClass('showing-modal');
  });

  // Add upgrade modal
  $('.product .btn--add').on('click', function (e) {
    e.preventDefault();

    // Stop it being modal, make it visible inline on page
    $(this).closest('.product').removeClass('product--modal').addClass('active');
  });

  // Add-on Products
  $('.card .pdp__add-ons .form__group--check input').on('change', function () {
    if (this.checked) {
      // Get price, var id, etc
      var addPrice = $(this).closest('.form__group').attr('data-price');
      var currentPrice = $(this).closest('.product').find('.money').attr('data-price_raw');
      var newPrice = parseInt(currentPrice) + parseInt(addPrice);

      // Change visual price
      $(this).closest('.add-on').addClass('active');
      $(this).closest('.product').find('.money').attr('data-price_raw', parseInt(newPrice));
      $(this).closest('.product').find('.money').text(formatter.format(parseInt(newPrice) / 100));
    } else {
      var addPrice = $(this).closest('.form__group').attr('data-price');
      var currentPrice = $(this).closest('.product').find('.money').attr('data-price_raw');
      var newPrice = parseInt(currentPrice) - parseInt(addPrice);

      // Change visual price
      $(this).closest('.add-on').removeClass('active');
      $(this).closest('.product').find('.money').attr('data-price_raw', parseInt(newPrice));
      $(this).closest('.product').find('.money').text(formatter.format(parseInt(newPrice) / 100));
    }
  });
  var prodIds = [];

  // Add products to cart
  $('.btn--atc-quiz').on('click', function (e) {
    e.preventDefault();

    // Go through each product that exists
    $('.product').each(function () {
      // If it's active, add the variant ID to the object array
      if ($(this).hasClass('active')) {
        var $items = $(this).find('.add-on');
        var prodVarId = $(this).attr('data-var_id');
        prodIds.push({
          id: prodVarId,
          quantity: '1'
        });

        // If it has addons, check if those are selected and add to array as well
        $.each($items, function () {
          var input = $(this).find('input');
          if (input.is(':checked') == true) {
            var addonId = $(this).find('.form__group').attr('data-varid');
            prodIds.push({
              id: addonId,
              quantity: '1'
            });
          }
        });
      }
    });

    // Finally, add it to the cart
    CartJS.addItems(prodIds, {
      "success": function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      "error": function error(jqXHR, textStatus, errorThrown) {
        alert('Error: ' + errorThrown + '!');
      }
    });
  });
});
function matchObjects(answerArray, masterArray, matchArray) {
  // Loop through all the possible answer combos in our giant array
  $.each(masterArray, function (index, item) {
    // If our current quiz answers match an object in the array
    if (JSON.stringify(answerArray) == JSON.stringify(item)) {
      // Define what product should be displayed
      var matchProducts = matchArray[index].split(':');
      console.log(matchProducts);

      // Show the products card
      $('.card').hide();
      $('.card--product').show();

      // Show matching products on product card
      $.each(matchProducts, function (index, item) {
        $('.product[data-prod="' + item + '"]').addClass('active');
      });
    }
  });
}
function setPercent(percent) {
  $('.quiz__progress .progress').css('width', percent + '%');
}
jQuery(document).ready(function ($) {
  // Hero--full Slider
  $('.hero--full .hero__slider').slick({
    fade: true,
    autoplaySpeed: 3600,
    autoplay: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: false,
    responsive: [{
      breakpoint: 576,
      settings: {
        arrows: false
      }
    }]
  });
  $('.scroller .scroller__wrap').slick({
    speed: 15000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    arrows: false,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    pauseOnHover: true
  });

  // PDP Default image slider
  $('.pdp__images--default .pdp__slider--thumb').slick({
    infinite: true,
    arrows: true,
    dots: false,
    slidesToShow: 6,
    vertical: true,
    focusOnSelect: true,
    asNavFor: '.pdp__images--default .pdp__slider--main'
  });
  $('.pdp__images--default .pdp__slider--main').slick({
    infinite: true,
    fade: true,
    arrows: false,
    dots: false,
    asNavFor: '.pdp__images--default .pdp__slider--thumb',
    responsive: [{
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: true,
        adaptiveHeight: true
      }
    }]
  });
  $('.pdp__slider .slider').slick({
    fade: false,
    slidesToShow: 1,
    dots: false,
    arrows: true,
    adaptiveHeight: true,
    responsive: [{
      breakpoint: 992,
      settings: "unslick"
    }]
  });
  $('.pdp__social .social__images').slick({
    fade: false,
    slidesToShow: 4,
    dots: false,
    arrows: true,
    responsive: [{
      breakpoint: 992,
      settings: {
        arrows: false,
        dots: false,
        centerMode: true,
        slidesToShow: 1,
        variableWidth: true
      }
    }]
  });

  // Cart Related
  $('.cart__related .slider').slick({
    fade: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: false,
    arrows: true,
    appendArrows: '.scroll-nav',
    responsive: [{
      breakpoint: 768,
      settings: "unslick"
    }]
  });

  // Crew
  $('.banner--crew .slider').slick({
    fade: true,
    slidesToShow: 1,
    dots: false,
    arrows: true,
    adaptiveHeight: true
  });
  $('.community-grid .mobile-stuff').slick({
    fade: false,
    slidesToShow: 1,
    dots: true,
    arrows: false,
    adaptiveHeight: false
  });
  $('.newbrew-steps .slider').slick({
    fade: true,
    slidesToShow: 1,
    dots: false,
    arrows: true,
    adaptiveHeight: false,
    responsive: [{
      breakpoint: 992,
      settings: "unslick"
    }]
  });
  $('.video-slider__thumbs').slick({
    infinite: true,
    arrows: true,
    dots: false,
    slidesToShow: 3,
    focusOnSelect: true,
    asNavFor: '.video-slider__main',
    responsive: [{
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    }]
  });
  $('.video-slider__main').slick({
    infinite: true,
    fade: true,
    arrows: false,
    dots: false,
    asNavFor: '.video-slider__thumbs'
  });

  // const myInterval = setInterval( function(){
  //   if ( $( '.pdp__slider--thumb' ).hasClass( 'slick-initialized' ) ) {
  //     $( '.pdp__slider--thumb' ).fadeIn( 200, function(){
  //       $( '.pdp__slider--thumb' ).slick('setPosition');  
  //       clearInterval( myInterval );    
  //     } );

  //   }
  // }, 50 );

  // console.log( 'NOOM! ---?' );
  // const myInterval2 = setInterval( function(){
  //   if ( $( '.pdp__slider--main' ).hasClass( 'slick-initialized' ) ) { 
  //     $( '.pdp__slider--main' ).fadeIn( 200, function(){
  //       $( '.pdp__slider--main' ).slick('setPosition');     
  //       console.log( 'NOOM!' );
  //       clearInterval( myInterval2 );  
  //     } );

  //   }
  // }, 50 );

  // var $status = $('.newbrew-steps .slide-count span');
  // var $slickElement = $('.newbrew-steps .slider');

  // $slickElement.on('init reInit beforeChange', function(event, slick, currentSlide, nextSlide){
  //     //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  //     var i = (currentSlide ? currentSlide : 0) + 1;
  //     $status.html(('0' + i).slice(-2) + ' / ' + ('0' + slick.slideCount).slice(-2));
  // });

  // var $pdpStatus = $('.pdp__images .pdp__slider--main .pdp__slider-count');
  // var $pdpSlickElement = $('.pdp__images .pdp__slider--main');

  // $pdpSlickElement.on('init reInit beforeChange', function(event, slick, currentSlide, nextSlide){
  //     //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  //     var i = (currentSlide ? currentSlide : 0) + 1;
  //     $pdpStatus.text(('0' + i).slice(-2) + ' / ' + ('0' + slick.slideCount).slice(-2));
  // });
});
// Sleepify Starter Theme by Sleepless Media
//
// Main Javascript entry file. 

console.log("This site was developed by https://www.sleeplessmedia.com");

// Create our number formatter.
var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});
//Sleepify Starter Theme by Sleepless Media
//This file is intended to be used for small ongoing fixes or changes post-launch.